<template>

  <body>

    <div>
      <my-header> </my-header>
      <div class="mainWrap">
        <div class="main">
          <div class="breadCrumbs">
            <h3>{{productname}}</h3>
            <span>
              <a>首页</a> &gt;
             <router-link to="/MixedCellSeries">
            <a>产品</a> &gt;
            </router-link>  
              <a>{{productname}}</a> &gt;
              <em>{{productlist.title}}</em>
            </span>
          </div>
          <!--内容开始-->
          <div class="content">
            <div class="cr_protab">
              <a class="linkNext" @click="entercolor()">选择颜色</a>
              <a class="cur">选择线材和包装盒</a>
              <a>确认购买</a>
            </div>

            <div class="probuy_twocon">
              <dl>

                <dd>
                  <div class="ddlib">
                    <p class="borbottom">
                      <img :src="httpurl+Xiancai.image"
                           alt="">
                      <img :src="httpurl+Baozhuang.image"
                           alt="">

                    </p>
                  </div>
                  <div class="ddlib">
                    <div class="Ywwpic">
                      <img :src="httpurl +YwwpicRight.image" />
                      <img :src=" httpurl +YwwLagre.image" />
                    </div>
                  </div>

                </dd>

                <dt>
                  <h4 class="probuy_title">线材和包装盒</h4>
                  <div class="probuy_find zindex9"
                       @mouseenter="enter"
                       @mouseleave="leave">
                    <p class="probuy_findtext">
                      <em>￥{{Xiancai.price*discount}}</em>
                      <span>{{Xiancai.name}}</span>
                    </p>
                    <div class="probuy_subnav"
                         :style='{display:!selectWire?"none":"block"}'>
                      <p :imgsrc1="item.image"
                         v-for="(item,index) in Wires "
                         :key="index"
                         v-show='selectWire'
                         @click="chooseWire(item,index)">
                        <em>￥{{item.price*discount| toFixed(2)}}</em>
                        <span>{{item.name}}</span>
                      </p>
                    </div>
                  </div>
                  <div class="probuy_find zindex8"
                       @mouseenter="Boxenter"
                       @mouseleave="Boxleave">
                    <p class="probuy_findtext">
                      <em>￥{{Baozhuang.price*discount}}</em>
                      <span>{{Baozhuang.name}}</span>
                    </p>
                    <div class="probuy_subnav"
                         :style='{display:!selectBox?"none":"block"}'>
                      <p :imgsrc1="item.image"
                         v-for="(item,index) in Boxs "
                         v-show='selectBox'
                         :key="index"
                         @click="chooseBox(item,index)">
                        <em>￥{{item.price*discount| toFixed(2)}}</em>
                        <span>{{item.name}}</span>
                      </p>

                    </div>
                  </div>

                  <h4 class="probuy_title">包装盒刻字</h4>
                  <form class="probuy_form">
                    <p>姓名</p>
                    <label><input type="text"
                             v-model="infolist.name"
                             id="txtKeZiName"></label>
                    <h4 class="probuy_title">附加信息</h4>
                    <p>款式</p>
                    <label><input type="text"
                             v-model="infolist.style"
                             id="txtOther1"></label>
                    <p>材质</p>
                    <label><input type="text"
                             v-model="infolist.quality"
                             id="txtOther2"></label>
                    <p>其他要求</p>
                    <label><input type="text"
                             v-model="infolist.elseask"
                             id="txtOther3"></label>
                  </form>
                </dt>

              </dl>

              <div class="probuy_twoconlist">
                <div class="pro_listleft">
                  <span v-html="productlist.content">
                    {{productlist.content}}
                  </span>

                </div>
                <div class="pro_listright">
                  <span>￥{{sum| toFixed(2)}}</span>
                  <a href="javascript:;"
                     class="linkNext"
                     @click='EnterPurchase(sum)'>立即购买</a>

                  <p>如果您有任何疑问或需要帮助，请致电<em>0755-86185918</em></p>
                </div>
              </div>
            </div>

          </div>

          <!--内容结束-->
        </div>
      </div>
    </div>

  </body>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { getxcbz } from "@/api/api";
import Config from "@/api/config";
import myHeader from "@/views/detailimg";
export default {
  components: { myHeader },

  data () {
    return {
      newsum: 0.00,
      httpurl: "http://shop.qdc.com/",
      productname: '',
      productid: '',
      daohang: false, //显示导航
      screenWidth: document.body.clientWidth, // 屏幕尺寸
      infolist: {
        name: "",
        elseask: '',
        style: '',
        quality: '',
      },

      // productname: '',
      ww: 100,
      price: 0,
        ukey:0,
      sum: 0,
      Xiancai: {
      },
      Baozhuang: {
      },
      productlist: '',
      selectWire: false,
      selectBox: false,
      YwwpicRight: '',
      YwwLagre: '',
      Boxs: [],
      Wires: [],
      discount:1
    };
  },
  created () {
    
    window.screenWidth = document.body.clientWidth;
    this.daohang = window.screenWidth > 1024 ? true : false;

    this.getxcbzList();
   
    if (localStorage.getItem("prpductnewlist") != null) {
      var list = JSON.parse(localStorage.getItem('prpductnewlist'));

      this.productlist = list
      this.productid = list.id
    

    }
    if (localStorage.getItem("newChildproductlist") != null) {
      var list2 = JSON.parse(localStorage.getItem('newChildproductlist'));
      this.productname = list2.name
    }else{
        if(this.$route.query.productmoreid){
             var list = JSON.parse(localStorage.getItem('prpductnewlist'));
            this.productname = list.parentname
        }
    }
   
    if (localStorage.getItem("newYwwLagre") != null) {
      var newYwwLagre = JSON.parse(localStorage.getItem('newYwwLagre'));
      this.YwwLagre = newYwwLagre

    }
    if (localStorage.getItem("newYwwpicRight") != null) {
      var newYwwpicRight = JSON.parse(localStorage.getItem('newYwwpicRight'));
      this.YwwpicRight = newYwwpicRight
    }
            
   if (localStorage.getItem('newukey') == '' || localStorage.getItem('newukey') == null) {
        this.ukey = 0
      }else{
          this.ukey=localStorage.getItem('newukey')
      }
  },
  computed: {},
  mounted () {
   
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;

        this.daohang = window.screenWidth > 1024 ? true : false;
      })();
    };
  },
  methods: {
    getxcbzListss () {
        
      var self = this;
       
      var para = {};
      getxcbz(para).then(res => {
        this.Xiancai = res.data.Wires[0]
        this.Baozhuang = res.data.Boxs[0]
        if(this.$route.query.newsum){
              this.newsum= parseFloat (this.$Base64.decode(this.$route.query.newsum));
        }else{
          this.newsum=0
        }
        if(localStorage.getItem('discount')!=null){
           this.discount=localStorage.getItem('discount')
        //    console.log('   this.discount'+   this.discount)
           this.sum= (parseFloat(res.data.Wires[0].price)+parseFloat(res.data.Boxs[0].price))*localStorage.getItem('discount')+parseFloat (this.newsum);
        }else{
             this.sum= parseFloat(res.data.Wires[0].price)+parseFloat(res.data.Boxs[0].price)+parseFloat (this.newsum);
        }
       
        this.$store.dispatch("ChangeXiancai",  this.Xiancai);
         this.$store.dispatch("ChangeBaozhuang",   this.Baozhuang );
         this.$store.dispatch("ChangeSum",  this.sum);
        res => {
          console.info("调用失败", res);
        };
      });
    },
    getxcbzList () {
      var self = this;
      var para = {};
      getxcbz(para).then(res => {
        this.Wires = res.data.Wires
        this.Boxs = res.data.Boxs
         this.getxcbzListss()
        res => {
          console.info("调用失败", res);
        };
      });
    },

    //通过点击按钮显示移动端导航
    showdao () {
      this.daohang = !this.daohang;
    },
    //跳转产品页面
    Toproduct () {
      this.$router.push("/");
      if (window.screenWidth < 1024) {
        this.daohang = !this.daohang;
      }
    },
    //跳转设计页面
    ToDesign () {
      this.$router.push("/Design");
    },
    chooseWire (item, index) {
      //				this.$set(item,'checked',!item.checked);
      this.number = index;
      if (item.id) {
        this.Xiancai.image = item.image;
        this.Xiancai.price = item.price;
        this.Xiancai.name = item.name;
        this.sum = parseFloat(this.newsum) + (parseFloat(this.Xiancai.price) + parseFloat(this.Baozhuang.price))*this.discount;
      }
      this.$store.dispatch("ChangeXiancai", item);
      this.selectWire = false;

    },
    chooseBox (item, index) {
      //				this.$set(item,'checked',!item.checked);
      this.number = index;
      if (item.id) {
        this.Baozhuang.image = item.image;
        this.Baozhuang.price = item.price;
        this.Baozhuang.name = item.name;
        this.sum = parseFloat(this.newsum) + (parseFloat(this.Xiancai.price) + parseFloat(this.Baozhuang.price))*this.discount;
      }

    //   console.log('包装盒：' + this.Baozhuang.name + this.Baozhuang.price)
    //   console.log('包装盒ss：' + this.Boxs[0])

      this.$store.dispatch("ChangeBaozhuang", item);
      this.selectBox = false;

    },
    enter: function () {
      this.selectWire = true;
      //				console.log('enter')
    },
    leave: function () {
      this.selectWire = false;
      //				console.log('leave')
    },
    Boxenter: function () {
      this.selectBox = true;
      //				console.log('enter')
    },
    Boxleave: function () {
      this.selectBox = false;
      //				console.log('leave')
    },
    product () {
      this.$router.push("/WirelessHeadset");
    },
    EnterPurchase (sum) {
       
        if(this.ukey==0){
              if(this.$route.query.productmoreid){
this.$router.push({

        path: '/EnterPurchase',
        query: {
          //    childid: item.id
        //   newsum:  this.newsum ,
         newsum:  this.$Base64.encode(this.newsum) ,
    
        productmoreid:this.$route.query.productmoreid,
         
        }

      });}else{
this.$router.push({

        path: '/EnterPurchase',
        query: {
          //    childid: item.id
        //   newsum:  this.newsum ,
          newsum:  this.$Base64.encode(this.newsum) ,
        }

      });
      }
           

        }   
        else if(this.ukey!==0){
            if(this.$route.query.productmoreid){
this.$router.push({

        path: '/EnterPurchase',
        query: {
          //    childid: item.id
        //   newsum:  this.newsum ,
           newsum:  this.$Base64.encode(this.newsum) ,
          ukey:this.ukey,
        productmoreid:this.$route.query.productmoreid,
         
        }

      });
            }else{
                this.$router.push({

        path: '/EnterPurchase',
        query: {
          //    childid: item.id
        //   newsum:  this.newsum ,
           newsum:  this.$Base64.encode(this.newsum) ,
          ukey:this.ukey,
       
         
        }

      });
            }
 
        }
          

       

      // if(this.infolist.name==''||this.infolist.name==null) {
      // 					this.$message({
      // 						message: "请输入姓名",
      // 						type: 'error'
      // 					});
      // 					return;
      //                 }
      //                 if(this.infolist.style==''||this.infolist.style==null) {
      // 					this.$message({
      // 						message: "请输入款式",
      // 						type: 'error'
      // 					});
      // 					return;
      //                 }
      //                 if(this.infolist.quality==''||this.infolist.quality==null) {
      // 					this.$message({
      // 						message: "请输入材质",
      // 						type: 'error'
      // 					});
      // 					return;
      // 				}
      //         if(this.infolist.elseask==''||this.infolist.elseask==null) {
      // 					this.$message({
      // 						message: "请输入其他要求",
      // 						type: 'error'
      // 					});
      // 					return;
      // 				}
      
    
      this.$store.dispatch("ChangeSum", sum);
      this.$store.dispatch("Changeaddinfo", this.infolist);


    },

    entercolor () {
        if(this.$route.query.productmoreid){
 this.$router.push({
          path: '/PurchaseFusion',
          query: {
            childid: this.productid,
            ukey:this.ukey,
            discount:this.$Base64.encode(localStorage.getItem('discount')),
            productmoreid:this.$route.query.productmoreid
          }

        });
        }else{
 this.$router.push({
          path: '/PurchaseFusion',
          query: {
            childid: this.productid,
            ukey:this.ukey,
            discount:this.$Base64.encode(localStorage.getItem('discount'))
          }

        });
        }
      
      alert("返回将重新选择，是否确定？");
    }
  }
};
</script>

<style scoped>
@import "../../static/newlayout.css";
</style>


// WEBPACK FOOTER //
// src/views/PurchaseFusionBox.vue